import { APICore } from './apiCore';

const api = new APICore();

interface CompanyData {
    id?: string;
    companyName: string;
    email: string;
    address: string;
    countryCode: string;
    mobile: string;
    phoneNumber: string;
    phoneNumberId: string;
    businessAccountId: string;
    appId: string;
    accessToken: string;
    logo?: File;
}

/**
 * Get company information
 * @returns {Promise}
 */
export function getCompany(companyId: string): Promise<any> {
    const baseUrl = `/company/${companyId}`;
    return api.get(baseUrl);
}

/**
 * Create new company
 * @param {FormData} companyData 
 * @returns {Promise}
 */
export function createCompany(companyData: FormData) {
    const baseUrl = '/company';
    return api.create(baseUrl, companyData);
}

/**
 * Update existing company
 * @param {string} companyId - The ID of the company to update
 * @param {FormData} companyData 
 * @returns {Promise}
 */
export function updateCompany(companyId: string, companyData: FormData) {
    const baseUrl = `/company/${companyId}`;
    return api.create(baseUrl, companyData);
}

/**
 * Delete company
 * @param {string} companyId - The ID of the company to delete
 * @returns {Promise}
 */
export function deleteCompany(companyId: string) {
    const baseUrl = `/company/${companyId}`;
    return api.delete(baseUrl);
}